module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training-clan-landing-big.b2fc5178.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training-clan-landing-big.png
// module id = 3803
// module chunks = 11